import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useClient } from 'react-supabase';
import { useOrg } from '../hooks/useOrg';
import { useUser } from '../hooks/useUser';
import { Approval } from './Approval';
import Authentication from './Authentication';
import Avatar from './Avatar';
import Logo from './Logo';
import RichText from './RichText';

function QuestionForm(_ref) {
  var title = _ref.title,
      onSubmit = _ref.onSubmit,
      _ref$subject = _ref.subject,
      subject = _ref$subject === void 0 ? true : _ref$subject,
      loading = _ref.loading,
      initialValues = _ref.initialValues;
  var user = useUser();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = onSubmit;

              if (!_context.t0) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return onSubmit(values);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: "squeak-form-frame"
  }, title && /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement(Formik, {
    initialValues: _extends({
      subject: '',
      question: ''
    }, initialValues),
    validate: function validate(values) {
      var errors = {};

      if (!values.question) {
        errors.question = 'Required';
      }

      if (subject && !values.subject) {
        errors.subject = 'Required';
      }

      return errors;
    },
    onSubmit: handleSubmit
  }, function (_ref3) {
    var _user$profile;

    var setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid;
    return /*#__PURE__*/React.createElement(Form, {
      className: "squeak-form"
    }, /*#__PURE__*/React.createElement(Avatar, {
      image: user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.avatar
    }), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      "class": "squeak-inputs-wrapper"
    }, subject && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "subject",
      name: "subject",
      placeholder: "Title",
      maxLength: "140"
    }), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("div", {
      className: "squeak-form-richtext"
    }, /*#__PURE__*/React.createElement(RichText, {
      setFieldValue: setFieldValue,
      initialValue: initialValues === null || initialValues === void 0 ? void 0 : initialValues.question
    }))), /*#__PURE__*/React.createElement("span", {
      className: "squeak-reply-buttons-row"
    }, /*#__PURE__*/React.createElement("button", {
      className: "squeak-post-button",
      style: loading || !isValid ? {
        opacity: '.5'
      } : {},
      disabled: loading || !isValid,
      type: "submit"
    }, user ? 'Post' : 'Login & post'), /*#__PURE__*/React.createElement("div", {
      className: "squeak-by-line"
    }, "by", /*#__PURE__*/React.createElement("a", {
      href: "https://squeak.posthog.com?utm_source=post-form"
    }, /*#__PURE__*/React.createElement(Logo, null))))));
  }));
}

export default function (_ref4) {
  var _user$profile2;

  var _ref4$formType = _ref4.formType,
      formType = _ref4$formType === void 0 ? 'question' : _ref4$formType,
      messageID = _ref4.messageID,
      onSubmit = _ref4.onSubmit;
  var supabase = useClient();

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId,
      apiHost = _useOrg.apiHost;

  var user = useUser();

  var _useState = useState(null),
      formValues = _useState[0],
      setFormValues = _useState[1];

  var _useState2 = useState(null),
      view = _useState2[0],
      setView = _useState2[1];

  var _useState3 = useState(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var buttonText = formType === 'question' ? /*#__PURE__*/React.createElement("span", null, "Ask a question") : /*#__PURE__*/React.createElement("span", {
    className: "squeak-reply-label"
  }, /*#__PURE__*/React.createElement("strong", null, "Reply"), " to question");

  var insertReply = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
      var _supabase$auth$sessio;

      var body, messageID;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              body = _ref5.body, messageID = _ref5.messageID;
              return _context2.abrupt("return", fetch(apiHost + "/api/reply", {
                method: 'POST',
                body: JSON.stringify({
                  body: body,
                  organizationId: organizationId,
                  messageId: messageID,
                  token: (_supabase$auth$sessio = supabase.auth.session()) === null || _supabase$auth$sessio === void 0 ? void 0 : _supabase$auth$sessio.access_token
                })
              }).then(function (res) {
                return res.json();
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function insertReply(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var insertMessage = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
      var _supabase$auth$sessio2;

      var subject, body, userID;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              subject = _ref7.subject, body = _ref7.body, userID = _ref7.userID;
              return _context3.abrupt("return", fetch(apiHost + "/api/question", {
                method: 'POST',
                body: JSON.stringify({
                  subject: subject,
                  body: body,
                  organizationId: organizationId,
                  token: (_supabase$auth$sessio2 = supabase.auth.session()) === null || _supabase$auth$sessio2 === void 0 ? void 0 : _supabase$auth$sessio2.access_token,
                  slug: window.location.pathname
                })
              }).then(function (res) {
                return res.json();
              }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function insertMessage(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleMessageSubmit = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(values) {
      var _supabase$auth$user;

      var userID, _view, _yield$insertMessage, messagePublished, _yield$insertReply, replyPublished;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              userID = (_supabase$auth$user = supabase.auth.user()) === null || _supabase$auth$user === void 0 ? void 0 : _supabase$auth$user.id;

              if (!userID) {
                _context4.next = 22;
                break;
              }

              _view = null;

              if (!(formType === 'question')) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return insertMessage({
                subject: values.subject,
                body: values.question
              });

            case 7:
              _yield$insertMessage = _context4.sent;
              messagePublished = _yield$insertMessage.published;

              if (!messagePublished) {
                _view = 'approval';
              }

            case 10:
              if (!(formType === 'reply')) {
                _context4.next = 16;
                break;
              }

              _context4.next = 13;
              return insertReply({
                body: values.question,
                messageID: messageID
              });

            case 13:
              _yield$insertReply = _context4.sent;
              replyPublished = _yield$insertReply.published;

              if (!replyPublished) {
                _view = 'approval';
              }

            case 16:
              if (onSubmit) {
                onSubmit(values);
              }

              setLoading(false);
              setView(_view);
              setFormValues(null);
              _context4.next = 25;
              break;

            case 22:
              setFormValues(values);
              setView('auth');
              setLoading(false);

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleMessageSubmit(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();

  return view ? {
    'question-form': /*#__PURE__*/React.createElement(QuestionForm, {
      subject: formType === 'question',
      initialValues: formValues,
      loading: loading,
      onSubmit: handleMessageSubmit
    }),
    auth: /*#__PURE__*/React.createElement(Authentication, {
      banner: {
        title: 'Please signup to post.',
        body: 'Create an account to ask questions & help others.'
      },
      buttonText: {
        login: 'Login & post question',
        signUp: 'Sign up & post question'
      },
      setParentView: setView,
      formValues: formValues,
      handleMessageSubmit: handleMessageSubmit,
      loading: loading
    }),
    login: /*#__PURE__*/React.createElement(Authentication, {
      setParentView: setView,
      formValues: formValues,
      handleMessageSubmit: function handleMessageSubmit() {
        return setView(null);
      },
      loading: loading
    }),
    approval: /*#__PURE__*/React.createElement(Approval, {
      handleConfirm: function handleConfirm() {
        return setView(null);
      }
    })
  }[view] : /*#__PURE__*/React.createElement("div", {
    className: "squeak-reply-buttons"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: user === null || user === void 0 ? void 0 : (_user$profile2 = user.profile) === null || _user$profile2 === void 0 ? void 0 : _user$profile2.avatar
  }), /*#__PURE__*/React.createElement("button", {
    className: formType === 'reply' ? 'squeak-reply-skeleton' : 'squeak-ask-button',
    onClick: function onClick() {
      return setView('question-form');
    }
  }, buttonText), formType === 'question' && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      if (user) {
        supabase.auth.signOut();
      } else {
        setView('login');
      }
    },
    className: "squeak-logout-button"
  }, user ? 'Logout' : 'Login'));
}